// actions.js
import { createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
    getBankVerificationInitialData: ['initialData'],
});

export default { Creators, Types };